import { BankAccountForm, Confirm, Documents, SelectBankAccount, SocialReasonForm } from './components/steps';
export const COMMERCIAL_PROCESS_STEPS_COMPONENTS = {
    'select-bank-account': SelectBankAccount,
    'bank-account-modification': BankAccountForm,
    'social-reason-modification': SocialReasonForm,
    documents: Documents,
    confirm: Confirm,
};
